Currency    = require 'models/currency.coffee'
all_periods = _.flatten(_.map (require 'models/transaction_periods.coffee'), 'periods')

module.exports = class Transaction
  constructor: (obj = {}) ->
    obj.id   ||= null
    obj.date ||= hm_date.constants.today
    obj.type ||= 'unplanned'
    obj.subtype ||= 'e'
    obj.currency ||= null
    obj.virtual_id ||= -1
    obj.category ||= ''
    obj.description ||= ''
    obj.planned_repeat_days ||= 0
    obj.planned_repeat_end ||= 'always'
    obj.planned_repeat_end_date ||= null
    obj.transfer_to_amount ||= null if (obj.transfer_to_amount == undefined)
    obj.transfer_type ||= 'a'
    obj.account_id ||= null
    obj.virtual_id ||= null
    obj.real_amount = null if !_.isNumber(obj.real_amount)
    obj.plan_amount = null if !_.isNumber(obj.plan_amount)
    obj.common_id ||= null
    obj.transfer_from_id ||= undefined
    obj.transfer_to_id ||= undefined
    obj.transfer_to_currency ||= null

    _.merge(@, obj)
  isIncome:                  -> @subtype == 'i'
  isExpense:                 -> @subtype == 'e'
  isTransfer:                -> @subtype == 't'
  isTransferBetweenAccounts: -> @isTransfer() && @transfer_type == 'a'
  isTransferBetweenVirtuals: -> @isTransfer() && @transfer_type == 'v'
  isUnplanned:               -> @type == 'unplanned'
  isPlanned:                 -> @type == 'planned'
  isConfirmed:               -> _.isNumber(@real_amount) && !@isNew()
  isUnconfirmed:             -> !@isConfirmed()
  isNew:                     -> _.isNil(@id)
  isFuture:                  -> @date >= hm_date.constants.today

  amount: -> if _.isNumber(@real_amount) then @real_amount else 0
  sortable_amount_usd: ->
    amount = if _.isNumber(@real_amount) then @real_amount else @plan_amount
    return Currency.convert(amount, @currency, 'usd')
  amountInUsd: -> Currency.convert(@amount(), @currency, 'usd')
  planAmountInUsd: ->
    @plan_amount ||= 0
    return 0 if @plan_amount == 0
    return Currency.convert(@plan_amount, @currency, 'usd')

  isRelatedToAccount: (account_id) ->
    if @isTransfer()
      return @isTransferBetweenAccounts() && (@transfer_from_id == account_id || @transfer_to_id == account_id)
    else
      return @account_id == account_id

  isRelatedToVirtual: (virtual_id) ->
    if @isTransfer()
      return @isTransferBetweenVirtuals() && (@transfer_from_id == virtual_id || @transfer_to_id == virtual_id)
    else
      return @virtual_id == virtual_id

  signRelatedToAccountVirtual: (filter) ->
    return '–' if filter.virtual_id && filter.virtual_id == @transfer_from_id
    return '+' if filter.virtual_id && filter.virtual_id == @transfer_to_id
    return '–' if filter.account_id && filter.account_id == @transfer_from_id
    return '+' if filter.account_id && filter.account_id == @transfer_to_id

  isWithHiddenVirtual: ->
    if @virtual_id
      virtual = HM.store.getters.virtuals_find(@virtual_id)
      return true if virtual && virtual.hidden
    if @isTransferBetweenVirtuals()
      transfer_from = HM.store.getters.virtuals_find(@transfer_from_id)
      return true if transfer_from && transfer_from.hidden
      transfer_to = HM.store.getters.virtuals_find(@transfer_to_id)
      return true if transfer_to && transfer_to.hidden
    return false

  isWithHiddenAccount: ->
    if @account_id
      account = HM.store.getters.accounts_find(@account_id)
      return true if account && account.isHidden()
    if @isTransferBetweenAccounts()
      transfer_from = HM.store.getters.accounts_find(@transfer_from_id)
      return true if transfer_from && transfer_from.isHidden()
      transfer_to = HM.store.getters.accounts_find(@transfer_to_id)
      return true if transfer_to && transfer_to.isHidden()
    return false

  baseCategory: ->
    return '' if _.isEmpty(@category)
    return @category.split('/')[0].trim()
  subCategory: ->
    return '' if _.isEmpty(@category)
    return _.drop(@category.split('/')).join('/').trim()

  fAmount: (options = {}) ->
    if @isTransferBetweenAccounts()
      currency = HM.store.getters.accounts_find(@transfer_from_id).currency
    else if @isTransferBetweenVirtuals()
      currency = HM.store.getters.virtuals_find(@transfer_from_id).currency
    else
      currency = @currency

    default_options =
      value: (if _.isNumber(@real_amount) then @real_amount else @plan_amount)
      currency: currency
      sign: if @isTransfer() then 'transfer' else 'force'
    Currency.format(_.merge {}, default_options, options)
  fDescription: (display_tags = false)  ->
    amount = if _.isNumber(@real_amount) then @real_amount else @plan_amount
    abs_amount = Math.abs(amount) + ''
    description = if @description == abs_amount then '' else @description
    strings_to_replace = ["#{abs_amount}.00", "#{abs_amount}.0", "#{abs_amount}0", abs_amount]
    for str in strings_to_replace
      description = description.replace(str,'') if description.indexOf(str) == 0
    description = description.replace /\n/g,'<br>' if display_tags
    if @isTransfer() && _.isEmpty(description)
      description = if HM.is_russian then 'перевод' else 'transfer'
    return description

  fAccountNames: ->
    deleted_account = if HM.is_russian then '--удалённый счёт--' else '--deleted--'
    divider = ' => '
    if @isTransferBetweenAccounts()
      account_1 = HM.store.getters.accounts_find(@transfer_from_id)?.name
      account_2 = HM.store.getters.accounts_find(@transfer_to_id)?.name
    else if @isTransferBetweenVirtuals()
      account_1 = HM.store.getters.virtuals_find(@transfer_from_id)?.name
      account_2 = HM.store.getters.virtuals_find(@transfer_to_id)?.name
    else
      divider = ' / '
      account_1 = HM.store.getters.accounts_find(@account_id)?.name
      account_2 = HM.store.getters.virtuals_find(@virtual_id)?.name
    "#{ account_1 || deleted_account } #{ divider } #{ account_2 || deleted_account }"

  fShortCategory: -> _.truncate(@category, {length: 20})
  fSubtype: ->
    return 'income'   if @isIncome()
    return 'expense'  if @isExpense()
    return 'transfer_accounts' if @isTransferBetweenAccounts()
    return 'transfer_virtuals' if @isTransferBetweenVirtuals()

  fullSubtype: ->
    subtype = switch @subtype
      when 'e' then 'expense'
      when 'i' then 'income'
      when 't' then 'transfer'
    if subtype == 'transfer'
      subtype = 'transfer_accounts' if @transfer_type == 'a'
      subtype = 'transfer_virtuals' if @transfer_type == 'v'
    return subtype

  fPlannedInfo: ->
    return '' if @isUnplanned()
    return '' if @planned_repeat_days == 0
    info = _.find(all_periods, { days: @planned_repeat_days })?.localizedName()
    if @planned_repeat_end == 'always'
      info += ' (всегда)' if HM.is_russian
      info += ' (always)' if HM.is_english
    else
      info += " (до #{@planned_repeat_end_date})" if HM.is_russian
      info += " (till #{@planned_repeat_end_date})" if HM.is_english
    return info

  cssClasses: ->
    result = []
    result.push 'tr-income'            if @isIncome()
    result.push 'tr-expense'           if @isExpense()
    result.push 'tr-accounts-transfer' if @isTransferBetweenAccounts()
    result.push 'tr-virtuals-transfer' if @isTransferBetweenVirtuals()
    result.push 'tr-planned'           if @isExpense()
    result.push 'tr-confirmed'         if @isConfirmed()
    result.push 'tr-unconfirmed'       if @isUnconfirmed()
    result

  descriptionSum: -> Currency.calculateString(@description)


  omitPrivateParams: ->
    for key in Object.keys(@)
      _.unset(@, key) if _.startsWith(key, '_')
    return @

  ###*
   * Currency of the real / transfer_from account
   * @param  {object} user object to search for accounts/virtuals
   * @return {string}      currency
  ###
  accountCurrency: (user) ->
    if @isTransfer()
      currency = HM.store.getters.accounts_find(@transfer_from_id)?.currency if @isTransferBetweenAccounts()
      if @isTransferBetweenVirtuals()
        currency = HM.store.getters.virtuals_find(@transfer_from_id)?.currency
        currency = user.userdata.default_currency if @transfer_from_id == -1
    else
      currency = HM.store.getters.accounts_find(@account_id)?.currency
    return currency
